import React from 'react'
import { Pagination, PaginationLink } from 'reactstrap'

export function PageNavigator({setPage, pages, active}) {
	return <Pagination>
		{[...Array(pages).keys()].map((i) => <PaginationLink
			className={
				'w-seo-page-button' + (active === i + 1 ? ' active-page' : '')
			}
			type="button"
			onClick={(e) => {
				e.preventDefault()
				setPage(i + 1)
			}}
		>
			{i + 1}
		</PaginationLink>)}
	</Pagination>
}